import { useState, type ReactNode } from 'react'
import {
  MarketingAccessContext,
  type MarketingAccess,
} from './marketing-access-context'
export function MarketingAccessProvider({ children }: { children: ReactNode }) {
  const [access, setAccess] = useState<MarketingAccess | null>(null)
  return (
    <MarketingAccessContext value={{ access, setAccess }}>
      {children}
    </MarketingAccessContext>
  )
}
